import Vue from "vue";

const state = {
  salesInvoices: [],
  purchaseInvoices: [],
  commissionInvoices: [],
  saleInvoice: {},
  commissionInvoice: {},
  purchaseInvoice: {},
  total: 0
};

const getters = {};

const actions = {
  LOAD_PURCHASE_INVOICES: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get(
        "finance/purchase/invoices?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(res => {
        commit("SET_PURCHASE_INVOICES", res.data.purchaseInvoices);
        commit("SET_TOTAL", res.data.meta.total);
      });
  },
  LOAD_COMMISSION_INVOICES: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get(
        "finance/commission/invoices?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(res => {
        commit("SET_COMMISSION_INVOICES", res.data.commissionInvoices);
        commit("SET_TOTAL", res.data.meta.total);
      });
  },
  LOAD_SALES_INVOICES: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get(
        "finance/sale/invoices?from=" + payload.from + "&limit=" + payload.to
      )
      .then(res => {
        commit("SET_SALE_INVOICES", res.data.salesInvoices);
        commit("SET_TOTAL", res.data.meta.total);
      });
  },
  LOAD_SALES_INVOICE: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get("finance/sale/invoices/" + payload)
      .then(res => {
        commit("SET_SALE_INVOICE", res.data.salesInvoice);
      });
  },
  LOAD_COMMISSION_INVOICE: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get("finance/commission/invoices/" + payload)
      .then(
        res => {
          commit("SET_COMMISSION_INVOICE", res.data.commissionInvoice)
        }
      )
  },
  LOAD_PURCHASE_INVOICE: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get("finance/purchase/invoices/" + payload)
      .then(
        res => {
          commit("SET_PURCHASE_INVOICE", res.data.purchaseInvoice)
        }
      )
  }
};

const mutations = {
  SET_PURCHASE_INVOICES: function(state, payload) {
    state.purchaseInvoices = payload;
  },
  SET_COMMISSION_INVOICES: function(state, payload) {
    state.commissionInvoices = payload;
  },
  SET_SALE_INVOICES: function(state, payload) {
    state.salesInvoices = payload;
  },
  SET_SALE_INVOICE: function(state, payload) {
    state.saleInvoice = payload;
  },
  SET_COMMISSION_INVOICE: function(state, payload) {
    state.commissionInvoice = payload
  },
  SET_PURCHASE_INVOICE: function(state, payload) {
    state.purchaseInvoice = payload
  },
  SET_TOTAL: function(state, payload) {
    state.total = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
